'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _commonWebLocalization = require('../../localization/commonWebLocalization');

var _commonWebLocalization2 = _interopRequireDefault(_commonWebLocalization);

var _ = require('.');

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeliverySearchContainer = function (_Component) {
    _inherits(DeliverySearchContainer, _Component);

    function DeliverySearchContainer() {
        var _temp, _this, _ret;

        _classCallCheck(this, DeliverySearchContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
    }

    DeliverySearchContainer.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        this.props.Store.addChangeListener('GET_DELIVERY_AVAILABILITY_SUCCESS', function () {
            return _this2.updateDeliveryAvailability();
        });
        this.props.Store.addChangeListener('GET_DELIVERY_AVAILABILITY_FAILURE', function () {
            return _this2.updateDeliveryAvailability;
        });
    };

    DeliverySearchContainer.prototype.componentWillUnmount = function componentWillUnmount() {
        var _this3 = this;

        this.props.Store.removeChangeListener('GET_DELIVERY_AVAILABILITY_SUCCESS', function () {
            return _this3.updateDeliveryAvailability();
        });
        this.props.Store.removeChangeListener('GET_DELIVERY_AVAILABILITY_FAILURE', function () {
            return _this3.updateDeliveryAvailability;
        });
    };

    DeliverySearchContainer.prototype.render = function render() {
        var _this4 = this;

        return _react2.default.createElement(_2.default, {
            onSelect: function onSelect(address) {
                return _this4.getDeliveryAvailability(address);
            },
            buttonLabel: this.getButtonLabel(),
            redirectUrl: this.state.url,
            cntry: this.props.cntry,
            lang: this.props.lang,
            googleMapsHelper: this.props.googleMapsHelper,
            deliveryUnavailableError: this.getDeliveryServiceError()
        });
    };

    DeliverySearchContainer.prototype.getDeliveryAvailability = function getDeliveryAvailability(address) {
        if (!this.props.Actions && !this.props.Actions.getDeliveryAvailability) {
            return false;
        }
        this.setState({
            // Need to localize this
            label: _commonWebLocalization2.default.get('delivery_search_loading', this.props.lang, this.props.cntry) + '...',
            url: ''
        });
        this.props.Actions.getDeliveryAvailability(address);
    };

    DeliverySearchContainer.prototype.updateDeliveryAvailability = function updateDeliveryAvailability() {
        var details = this.props.Store.getDeliveryDetails();
        this.setState({
            label: details.label,
            url: details.url,
            serviceMessages: details.serviceMessages
        });
    };

    DeliverySearchContainer.prototype.getButtonLabel = function getButtonLabel() {
        return this.state.label || '' + _commonWebLocalization2.default.get('delivery_search_button', this.props.lang, this.props.cntry);
    };

    DeliverySearchContainer.prototype.getDeliveryServiceError = function getDeliveryServiceError() {
        if (Array.isArray(this.state.serviceMessages)) {
            return this.state.serviceMessages[0];
        }
    };

    return DeliverySearchContainer;
}(_react.Component);

DeliverySearchContainer.propTypes = {
    Actions: _propTypes2.default.shape({
        getDeliveryAvailability: _propTypes2.default.func.isRequired
    }).isRequired,
    Store: _propTypes2.default.shape({
        addChangeListener: _propTypes2.default.func.isRequired,
        removeChangeListener: _propTypes2.default.func.isRequired
    }),
    googleMapsHelper: _propTypes2.default.func.isRequired,
    cntry: _propTypes2.default.string.isRequired,
    lang: _propTypes2.default.string.isRequired
};

exports.default = DeliverySearchContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/DeliverySearch/DeliverySearchContainer.js
// module id = 791
// module chunks = 0